import {Footer} from "./components/Layouts/Footer";
import AllRoutes from "./routes/AllRoutes";
function App() {
  return (
    <div className="App">
      <AllRoutes/>
      <Footer/>
    
    </div>
  );
}

export default App;
